export const ACTIONS = {
  STATISTICS_FETCH_START: 'STATISTICS_FETCH_START',
  STATISTICS_FETCH_SUCCESS: 'STATISTICS_FETCH_SUCCESS',
  STATISTICS_FETCH_FAILURE: 'STATISTICS_FETCH_FAILURE',
  STATISTICS_FETCH_RESET: 'STATISTICS_FETCH_RESET',
};
